import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type InitSlice = {
  vapidPublicKey: string;
  premiumLimit: PremiumLimit | null;
  supportedCurrencies: SupportedCurrencies;
  userInfo: {
    isPremium: boolean;
    itemCount: number;
  };
}

const initialState = {
  vapidPublicKey: "",
  premiumLimit: null,
  supportedCurrencies: {},
  userInfo: {
    isPremium: false,
    itemCount: 0
  }
} as InitSlice

export const init = createSlice({
  name: "initSlice",
  initialState: initialState,
  reducers: {
    updateInitSlice: (state, action: PayloadAction<InitSlice>) => {
      return structuredClone(action.payload)
    },
    resetInitSlice: () => structuredClone(initialState)
  }
})

export const {
  updateInitSlice,
  resetInitSlice
} = init.actions

export default init.reducer
